import React, { Component } from 'react';
import './page.css'
import {serverUrl} from '../../utils/restUtils'

class Home extends Component {
    
    render() {

	const {pages, match: {params: {name}}} = this.props

	if(pages){
	    const page = pages.filter((page) => page.title===name)[0]
	    return (

		<div className="Page">
		    <div className="titleBox">
			<img src={page.image_id ? serverUrl()+'/images/'+page.image_id : '/images/noimage.png'} alt={page.title} />
			<div className="title">{page.title}</div>
		    </div>
		    
		    <div className="description" dangerouslySetInnerHTML={{__html: page.description.replace(new RegExp("src=\"api/", 'g'), "src=\""+serverUrl()+'/')}}></div>
		</div>
		
	    )
	}
	else{
	    return (<div></div>)
	}
    }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Page/index.jsx